module.exports = __webpack_public_path__ + "static/media/prism - browser stats.3f95449a.png";